import type { CurrentUser as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';

export type CurrentUser = {
  id: number;
  email: string;
  name?: string | null;
  superadmin: boolean;
};

export const fromGql = (item: GQLItem): CurrentUser =>
  take<CurrentUser>(item, 'id', 'email', 'name', 'superadmin');
